import { getCountryForTimezone } from 'countries-and-timezones';
import { PhoneNumber, PhoneNumberUtil } from 'google-libphonenumber';

import { Micros } from '../models/common.models';
import { isGermanLocale } from '../services/metrics-calculations.service';

export function splitNumberInto(size, divisor): number[] {
  return new Array(Math.floor(size / divisor)).fill(divisor).concat(size % divisor);
}

export function microsToNumber(micros: Micros, decimals?: number): number {
  const value = micros ? micros / 1000000 : 0;

  return decimals != null ? roundDecimals(value, decimals) : value;
}
export function numberToMicros(micros: number): Micros {
  return micros ? micros * 1000000 : 0;
}

export function roundDecimals(value: number, decimals: number): number {
  return +value.toFixed(decimals);
}

export function getTickRange(range: number, preferredTickLength: number): number {
  const step = range / preferredTickLength;
  let interval = 0.01;
  let previousInterval = 0.01;
  let multiplier = 5;

  while (step > interval) {
    previousInterval = interval;
    interval *= multiplier;
    multiplier = multiplier === 5 ? 2 : 5;
  }

  return Math.abs(step - interval) < Math.abs(step - previousInterval) ? interval : previousInterval;
}

export function numberBetween(x, arr) {
  const min = Math.min(...arr);
  const max = Math.max(...arr);
  return x >= min && x <= max;
}

export function getMaxMin(dt) {
  const arr = dt.filter((d) => !isNaN(d));
  const min = Math.min(...arr);
  const max = Math.max(...arr);
  return { min, max };
}

export function getCountryDialCode(defaultNumber = 49): number {
  let number = defaultNumber;
  const country = getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)?.id;

  if (country) {
    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    number = phoneNumberUtil.getCountryCodeForRegion(country);
  }

  return number || defaultNumber;
}

export function getPhoneNumber(value: string, regionCode?: string): PhoneNumber {
  if (!regionCode) {
    const country = getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    regionCode = country?.id;
  }

  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const hasPlusOrZero = value.startsWith('+') || value.startsWith('00');
  return phoneNumberUtil.parseAndKeepRawInput(value, hasPlusOrZero ? null : regionCode);
}

export const isValidNumber = (value: string) => !(isGermanLocale() ? isNaN(+value.replace(',', '.')) : isNaN(+value));

export function roundedTo(data, number = 2) {
  const result = Object.keys(data).reduce(
    (acc, key) => {
      const value = data[key];
      if (typeof value === 'number') {
        const valueStr = value.toString();
        const decimals = valueStr.split('.')[1];
        if (decimals && decimals.length > number) {
          acc[key] = parseFloat(value.toFixed(number));
        } else {
          acc[key] = value;
        }
      } else {
        acc[key] = value;
      }
      return acc;
    },
    <any>{},
  );

  return result;
}

export function convertStringToNumber(value): number {
  return typeof value === 'string' && !isNaN(<any>value) ? +value : value;
}

export const isInvalidNumber = (val) => val === null || val === '-' || typeof +val !== 'number' || isNaN(val);
